// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__zburF","title":"Info_title__FCinC","links":"Info_links__16b_c","link":"Info_link__2_bUH","logo":"Info_logo__-65Zz"};